import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

let templateConteudos = $(".templateConteudos");
if (templateConteudos.length > 0) {
    const csrfToken = $('meta[name="csrf-token"]').attr("content");
    changeContent();

    $(".filtros .tag").on("click", function () {
        $(".tag").removeClass("active");
        $(".tag").css("background-color", "#FFF");

        $(".tag").each((i, el) => {
            const color = $(el).attr("data-color");
        });

        $(this).addClass("active");
        if ($(".tag").hasClass("active")) {
        }

        const tag = $(this).data("tag");
        const ordem = $("#filtroOrdemConteudo").val();

        // console.log(tag, ordem);

        changeContent(tag, ordem);
    });

    $("#btnCarregarMaisConteudos").on("click", function () {
        const tag = $(".filtros .tag.active").data("tag");
        const ordem = $("#filtroOrdemConteudo").val();
        let pagina = parseInt($("#pagina").val());
        changeContent(tag, ordem, pagina);
        pagina = pagina + 1;
        $("#pagina").val(pagina);
    });

    $("#filtroOrdemConteudo").on("change", function () {
        console.log("select mudou");
        const tag = $(".filtros .tag.active").data("tag") || 0;
        const ordem = $(this).val() || "recentes";
        $("#pagina").val(1); // resetar para página 1
        changeContent(tag, ordem, 1);
    });

    function changeContent($tag = 0, $ordem = 0, $pagina = 1) {
        $("#loadingWaiting").remove();
        $("#listaConteudos").append(
            '<p style="text-align:center; display: block; width:100%" id="loadingWaiting">Aguarde. Carregando...</p>'
        );

        $.get(
            "/get_contents",
            {
                categoria: $tag,
                orderby: $ordem,
                page: $pagina,
                _token: csrfToken,
            },
            function (dataReturn) {
                if (dataReturn) {
                    if (dataReturn.total > 0) {
                        $("#listaConteudos").html("");
                        for (let i = 0; i < dataReturn.data.length; i++) {
                            let autor = "";
                            let autorImage = "";

                            if (dataReturn.data[i].author) {
                                autor = dataReturn.data[i].author.name;
                                autorImage =
                                    dataReturn.url_folder +
                                    dataReturn.data[i].author.image;
                            }

                            let imagemCard = dataReturn.data[i].thumb ?
                                dataReturn.url_folder + dataReturn.data[i].thumb :
                                dataReturn.url_folder + dataReturn.data[i].image;

                            $("#listaConteudos").append(
                                templateContent(
                                    imagemCard,
                                    dataReturn.data[i].title,
                                    autorImage,
                                    autor,
                                    dataReturn.data[i].postDateFormatted,
                                    dataReturn.data[i].slug,
                                    dataReturn.data[i].category.title,
                                    dataReturn.data[i].category.color,
                                    dataReturn.data[i].downloadURL
                                )
                            );
                        }

                        $("#loadingWaiting").remove();

                        if (
                            $(".listaConteudos .topicoItem").length <
                            dataReturn.total
                        ) {
                            $("#paginacao").fadeIn();
                        } else {
                            $("#paginacao").fadeOut();
                        }
                    } else {
                        $("#loadingWaiting").remove();
                        $("#paginacao").fadeOut();
                    }
                }
            }
        );
    }
    function formatarData(dataStr) {
        if (!dataStr) return "";
        
        const data = new Date(dataStr);
        if (isNaN(data)) return "";

        const dia = data.getDate().toString().padStart(2, "0");
        const mes = data.toLocaleDateString("pt-BR", { month: "short" }).replace(".", "");
        const ano = data.getFullYear().toString().slice(-2);

        return `${dia} de ${mes} ${ano}`;
    }

    function templateContent(
        imagem,
        titulo,
        imagemAutor,
        autor,
        dataPost,
        link,
        categoria,
        corCategoria,
        downloadURL
    ) {
        let template = `
        <div class="col-12 topicoItem">
            <div class="card-conteudo">
                ${
                    downloadURL
                        ? `
                <a href="${downloadURL}" class="card-link">
                    <div class="conteudo-exclusivo">
                        <p class="conteudo-exclusivo-txt">Conteúdo exclusivo</p>
                    </div>
                `
                        : `<a href="/conteudos/${link}" class="card-link">`
                }
                <div class="card-image">
                    <img src="${imagem}" alt="${titulo}">
                </div>
                <div class="card-content">
                    <div class="card-meta">
                        <div class="card-date">${formatarData(dataPost)}</div>
                        <div class="card-source">${autor || 'Close-up Internacional'}</div>
                    </div>
                    <h3 class="card-title">${titulo}</h3>
                    <div class="card-footer">
                        <div class="card-cta">
                            <span class="leia-mais">Leia mais</span>
                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.00006 6.75732C0.447776 6.75732 6.10641e-05 7.20504 6.10352e-05 7.75732C6.10062e-05 8.30961 0.447776 8.75732 1.00006 8.75732L1.00006 7.75732L1.00006 6.75732ZM16.5731 8.46443C16.9637 8.07391 16.9637 7.44074 16.5731 7.05022L10.2092 0.686257C9.81864 0.295732 9.18548 0.295732 8.79495 0.686257C8.40443 1.07678 8.40443 1.70995 8.79495 2.10047L14.4518 7.75732L8.79495 13.4142C8.40443 13.8047 8.40443 14.4379 8.79495 14.8284C9.18548 15.2189 9.81864 15.2189 10.2092 14.8284L16.5731 8.46443ZM1.00006 7.75732L1.00006 8.75732L15.866 8.75732L15.866 7.75732L15.866 6.75732L1.00006 6.75732L1.00006 7.75732Z" fill="#82CCDD"/>
                            </svg>
                        </div>
                        <div class="card-category">
                            ${categoria}
                        </div>
                    </div>
                </div>
            </a>
        </div>
    `;

        return template;
    }
}
